export const STUDENT_EXPERIENCE_SECTION_ID = 'studentDashboardTitle'
